module.exports = "https://coursera_assets.s3.amazonaws.com/images/fec701185270cbee605ee52351fe3acf.png";